function addRecencyFunctionScore(query) {
  return {
    function_score: {
      query,
      functions: [
        {
          exp: {
            date: {
              scale: '14d',
              decay: 0.99, // high value slow decay
              offset: '7d'
            }
          }
        },
        {
          weight: 0.01 // minimum score to avoid zeroing out
        }
      ],
      score_mode: 'sum',
      boost_mode: 'multiply'
    }
  };
}

export default addRecencyFunctionScore;
